import { Box, Button } from '@mui/material'
import React, { useCallback } from 'react'
import useAppUtilities from '../../hooks/useAppUtilities'
import {
  BasicModalDrawer,
  BasicModalFooterMainContainer,
  BasicModalHeaderMainContainer,
  BasicModalHeaderTypography,
} from '../styled/modal/BasicModal.styled'
import CloseButton from '../ui/button/CloseButton'
import PlainModal from './PlainModal'

interface BasicModalProps {
  open: boolean
  handleClose: () => void
  children: React.ReactNode
  title?: string
  buttonName?: string
  cancelButtonName?: string
  deleteModal?: boolean
  onCancel?: () => void
  onConfirm?: () => void
  cancelIcon?: boolean
  modelWidth?: string
  isLoader?: boolean
  saveBtnDisabled?: boolean
  modelOpenType?: 'popup' | 'drawer'
}

const BasicModal: React.FC<BasicModalProps> = ({
  open,
  handleClose,
  children,
  title,
  buttonName,
  deleteModal,
  onCancel,
  onConfirm,
  cancelButtonName = 'Cancel',
  cancelIcon = true,
  modelWidth = '400px',
  isLoader = false,
  saveBtnDisabled = false,
  modelOpenType = 'popup',
}) => {
  const { isSmallScreen } = useAppUtilities()

  const FallbackHeaderModal = useCallback(
    () => (
      <BasicModalHeaderMainContainer>
        <BasicModalHeaderTypography>{title}</BasicModalHeaderTypography>
        {cancelIcon && <CloseButton color="primary" onClick={handleClose} />}
      </BasicModalHeaderMainContainer>
    ),
    [title, cancelIcon, handleClose],
  )
  const FallbackFooterModal = useCallback(
    () => (
      <BasicModalFooterMainContainer>
        <Button
          onClick={onCancel}
          fullWidth
          disabled={isLoader}
          variant="outlined"
        >
          {cancelButtonName}
        </Button>
        <Button
          onClick={onConfirm}
          fullWidth
          disabled={isLoader || saveBtnDisabled}
          type="submit"
          variant="contained"
          color={buttonName === 'Delete' || deleteModal ? 'error' : 'primary'}
        >
          {buttonName}
        </Button>
      </BasicModalFooterMainContainer>
    ),
    [
      cancelButtonName,
      buttonName,
      deleteModal,
      isLoader,
      saveBtnDisabled,
      onCancel,
      onConfirm,
    ],
  )

  return (
    <>
      {modelOpenType === 'drawer' && isSmallScreen ? (
        <BasicModalDrawer open={open} onClose={handleClose}>
          {title && <FallbackHeaderModal />}
          <Box>{children}</Box>
          {buttonName && <FallbackFooterModal />}
        </BasicModalDrawer>
      ) : (
        <PlainModal
          open={open}
          handleClose={handleClose}
          modelWidth={modelWidth}
        >
          {title && <FallbackHeaderModal />}
          <Box>{children}</Box>
          {buttonName && <FallbackFooterModal />}
        </PlainModal>
      )}
    </>
  )
}

export default BasicModal
